import { get, postDefine } from '@/utils/request'

/**
 * 获取业务大屏全部数据（走缓存）
 * 对标地图大屏的 getDashboardData
 */
export function getBusinessData(params) {
  return get('/api/dashboard/business-data', params)
}

/**
 * 清除业务大屏缓存
 */
export function clearBusinessCache() {
  return postDefine('/api/dashboard/business-data/clear-cache')
}

/**
 * 导入周预装机计划（Excel）
 * @param {FormData} formData - 包含 file 字段的 FormData
 */
export function importWeeklyPlans(formData) {
  return postDefine('/api/dashboard/business-data/weekly-plans/import', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

/**
 * 导入代理商指标（Excel）
 * @param {FormData} formData - 包含 file 字段的 FormData
 */
export function importAgentTargets(formData) {
  return postDefine('/api/dashboard/business-data/agent-targets/import', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}
